/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FACILITY_CONDUCTS_REGULAR_INTERNAL_REVIEWS_AND_OR_ASSESSMENTS_O',
              'FACILITY_CONDUCTS_REGULAR_REVIEWS_AND_OR_ASSESSMENTS_OF_SOCIAL_',
              'FACILITY_KEEPS_RECORDS_OF_THESE_ASSESSMENTS_AND_ANY_VIOLATIONS_',
              'RESULTS_ARE_REPORTED_TO_SENIOR_MANAGEMENT',
              'FACILITY_DOES_NOT_PERFORM_REGULAR_REVIEWS_AND_OR_ASSESSMENTS_ON',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_conduct_regular_reviews_andor_assessments_of_socia: valueSchema,
  },
}
